import React, {useState} from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart, Subtitle, CointainerFigureImage } from '../../components/AppComponents';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more'; 
import highchartsGroupedCategories from 'highcharts-grouped-categories';
import { figure67 } from '../../graphs/ar/figure67';
import { figure70 } from '../../graphs/ar/figure70';
import { figure71 } from '../../graphs/ar/figure71';
import { figure74 } from '../../graphs/ar/figure74';
import { figure75 } from '../../graphs/ar/figure75';
import { figure76 } from '../../graphs/ar/figure76';
import { figure81 } from '../../graphs/ar/figure81';

import Modal from "../../components/Modal";

// import { figure55 } from '../graphs/ar/figure55';
// eslint-disable-next-line
highchartsMore(Highcharts);
highchartsGroupedCategories(Highcharts);

const Sdg15 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="15"
                poster={require('../../images/poster-sdg-15.png').default}
                video={require('../../images/video-sdg-15.mp4').default}
                sdgImage={require('../../images/EN_15.svg').default}
                sdg="الهدف 15 من أهداف التنمية المستدامة"
                title="الحياة على البر"
                subtitle="إدارة الغابات على نحو مستدام، ومكافحة التصحر، ووقف تدهور الأراضي وعكس مساره، ووقف فقدان التنوع البيولوجي"
                summaryTable={require('../../images/Goal_15.zip').default}
                indicators={['15.1.1', '15.2.1', '15.3.1', '15.4.2', '15.6.1']}  
                indicatorsTitle="المؤشرات"
                summaryTableTitle= "(باللغة الإنجليزية) الخُمس الخامس"
            />

  <Container>
                <TitleSub title="نظرة عامة" />
<p>يواجه العالم أزمة كوكبية ثلاثية تتمثل في تغير المناخ والتلوث وفقدان التنوع البيولوجي. يزداد الاتجاه في فقدان الغابات وتدهور الأراضي وانقراض الأنواع سوءًا، مما يشكل تهديدًا خطيرًا لصحة الكوكب والناس. انخفض إجمالي مساحة الغابات في العالم بمقدار 100 مليون هكتار منذ عام 2000، على الرغم من أن معدل فقدان الغابات يبدو أنه تباطأ في السنوات الأخيرة. علاوة على ذلك، بين عامي 2015 و2019، كان العالم يفقد ما لا يقل عن 100 مليون هكتار من الأراضي الصحية والمنتجة كل عام. في حين ظل الغطاء النباتي للمناطق الجبلية مستقرًا تقريبًا عند حوالي 78 في المائة خلال الفترة 2000–2018، تشير البيانات العالمية المتاحة إلى أن نسبة الأراضي الجبلية المتدهورة تبلغ 1.6 في المائة من إجمالي المساحة الجبلية في العالم لنفس الفترة. وهناك مؤشرات مشجعة على أن اعتماد ممارسات الإدارة المستدامة للغابات قد تحسن على مدى العقد الماضي. وفي الوقت نفسه، يتخذ عدد متزايد من البلدان تدابير لتسهيل تبادل المواد الوراثية النباتية لتعزيز الحصول على المنافع وتقاسمها. </p>
<div id="section15.1.1">
                    <HeaderSdg 
                        title="مؤشر أهداف التنمية المستدامة 15.1.1"
                        subtitle="مساحة الغابات كنسبة من إجمالي مساحة الأرض"
                        badges={[
                            {color: '#ffff05', text: 'تقييم الحالة العالمية: بعيد جدًا عن الهدفتقييم الاتجاه'},
                            { color: '#ff6261', text: 'العالمي: لا يوجد تحسن'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'الهدف 15.1',
                            text: 'ضمان الحفظ والاستعادة والاستخدام المستدام للنظم الإيكولوجية للمياه العذبة البرية والداخلية وخدماتها بحلول عام 2020، ولا سيما الغابات والأراضي الرطبة والجبال والأراضي الجافة، بما يتماشى مع الالتزامات بموجب الاتفاقات الدولية.'
                        }}
                    />
                </div>

<p><i>في عام 2020، غطت الغابات 31.2 في المائة من إجمالي مساحة الأراضي، مما يعكس انخفاضًا بمقدار 100 مليون هكتار على مدى العقدين الماضيين</i></p>
<p>انخفضت نسبة إجمالي مساحة الأراضي في العالم التي تغطيها الغابات تدريجيًا من 31.9 في المائة في عام 2000 (4.2 مليار هكتار)، إلى 31.5 في المائة في عام 2010، وإلى 31.2 في المائة (4.1 مليار هكتار) في عام 2020(Figure 67). منذ تنفيذ خطة عام 2030 في عام 2015، شهد الغطاء الحرجي انخفاضًا عالميًا بنسبة 0.2 في المائة، أي ما يعادل حوالي 25 مليون هكتار. ويمثل هذا ما يقرب من ربع صافي خسائر مساحة الغابات التي تقارب 100 مليون هكتار على مدى العقدين الماضيين.</p>
<p>ينتج هذا الاتجاه العالمي عن الديناميكيات الإقليمية المتعارضة. أظهرت أوروبا وأمريكا الشمالية ومعظم المناطق في آسيا زيادة إجمالية في مساحة الغابات من عام 2000 إلى عام 2020 بسبب التشجير وجهود استعادة المناظر الطبيعية والتوسع الطبيعي للغابات (Figure 67). وعلى وجه الخصوص، زادت مساحة الغابات في شرق آسيا بنسبة 3.64 في المائة، في حين شهدت جنوب شرق آسيا انخفاضا بنسبة 3.65 في المائة في هذه الفترة. ومع ذلك، تباطأ توسع مساحة الغابات من عام 2010 إلى عام 2020 مقارنة بالفترة 2000–2010.</p>
<p>وعلى العكس من ذلك، حدثت خسائر كبيرة في مساحات الغابات على مدى السنوات العشرين الماضية في أمريكا اللاتينية وأفريقيا جنوب الصحراء الكبرى. وتتأثر أقل البلدان نمواً على وجه الخصوص بخسائر مناطق الغابات. في حين أن إزالة الغابات في أمريكا اللاتينية ناتجة عن تحويل الغابات لرعي الماشية، فإن المحرك المباشر الأكثر شيوعًا في أفريقيا جنوب الصحراء الكبرى هو التوسع في الأراضي الزراعية. التوسع الزراعي هو المحرك المباشر لما يقرب من 90 في المائة من إزالة الغابات على مستوى العالم. كان التوسع في الأراضي الزراعية أهم الدوافع المباشرة (49.6 في المائة) يليه رعي الماشية (38.5 في المائة). وشكل زيت النخيل وحده 7 في المائة من إزالة الغابات في العالم في الفترة 2000–2018.</p>
<p>تلعب الغابات دورًا مهمًا في سبل عيش ورفاهية سكان الريف والحضر. وهي تساهم بشكل خاص في تنظيم دورة المياه والتخفيف من تغير المناخ والاحتفاظ بمعظم التنوع البيولوجي الأرضي في العالم. يؤدي فقدان الغابات إلى تعطيل ديناميكيات النظام الإيكولوجي مع آثار واسعة الانتشار على المناخ والتفاعلات بين الإنسان والحياة البرية والروابط بين أنشطة استخدام الأراضي وتوفير خدمات النظام الإيكولوجي.</p>
<p>على الرغم من أنه لا يزال يتعين قياس الآثار القصيرة والطويلة الأجل لأزمة كوفيد-19 على منطقة الغابات، إلا أن الوباء كان له آثار مباشرة على الغطاء الحرجي والحراجة بسبب التغيرات في تدفق السكان من المناطق الحضرية والريفية والطلب الإضافي على بعض المنتجات الحرجية. واجهت العديد من المناطق الريفية، ولا سيما في المناطق المدارية، ضغوطًا متزايدة من إزالة الغابات وقطع الأشجار غير القانوني والصيد غير المشروع.</p>
<p>إن الحفاظ على الزخم بشأن وقف إزالة الغابات وتدهورها، واستعادة النظم الإيكولوجية المتضررة، أمر بالغ الأهمية لتحسين قدرة النظم الإيكولوجية على التكيف مع المناخ، وتجنب خسائر التنوع البيولوجي وتعزيز سبل العيش الريفية، لا سيما في المناطق المدارية وأقل البلدان نمواً.</p>
  </Container>
<ContainerChart
                title="الشكل 67. مساحة الغابات كنسبة من إجمالي مساحة الأرض، النسبة المئوية (2000 و2010 و2015 و2020)"
                legend={[
                    {title: '2000', color: '#70ad47'},
                    {title: '2010', color: '#a9d18e'},
                    {title: '2015', color: '#e2f0d9'},
                    {title: '2020', color: '#385723'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig67" download>https://doi.org/10.4060/CC7088EN-fig67</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure67}
                />
</ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 68. الاتجاه في مساحة الغابات كنسبة مئوية من إجمالي مساحة الأراضي (2015–2020)"
                legend={[
                    {title: 'التحسين', color: '#00a700'},
                    {title: 'تحسن طفيف أو معدوم', color: '#2acb2a'},
		    {title: 'تدهور طفيف', color: '#ffa500'},
		    {title: 'تلف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},			   
                ]}
                source={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (تم تعديله ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map68' src="fig68.html" width='100%'  height='500px'/>

            </ContainerChart>
 <Container>
                <div id="section15.2.1">
                    <HeaderSdg 
                        title="مؤشر أهداف التنمية المستدامة 15.2.1"
                        subtitle="ألف - التقدم المحرز صوب تحقيق الإدارة المستدامة للغابات"
                        badges={[
                            {color: '#cecece', text: 'تقييم الحالة العالمية: لم يتم إجراؤه لأسباب منهجية تقييم الاتجاه'},
                            {color: '#cecece', text: 'العالمي: لم يتم إجراؤه لأسباب منهجية'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'الهدف 15.2',
                            text: 'بحلول عام 2020، تعزيز تنفيذ الإدارة المستدامة لجميع أنواع الغابات، ووقف إزالة الغابات، واستعادة الغابات المتدهورة وزيادة التحريج وإعادة التحريج بشكل كبير على مستوى العالم.'
                        }}
                    />
                </div>

<p><i>يتقدم العالم نحو الإدارة المستدامة للغابات، لكن معدل فقدان الغابات لا يزال مرتفعًا</i></p>
<p>على الرغم من إحراز بعض التقدم على الصعيد العالمي نحو الإدارة المستدامة للغابات في العقد الماضي، إلا أن التقدم متفاوت عبر المناطق. بالإضافة إلى ذلك، تستمر غابات العالم في الانكماش، ويرجع ذلك أساسًا إلى التوسع في الزراعة لإنتاج المحاصيل والثروة الحيوانية.</p>
<p>في عام 2022، كانت 444 مليون هكتار من الغابات تخضع لنظام إصدار الشهاداتFigure 70 (). أظهرت مساحة الغابات المعتمدة زيادة بنسبة 29 في المائة، أي ما يعادل حوالي 100 مليون هكتار منذ عام 2010. ويلاحظ هذا الاتجاه الإيجابي بشكل رئيسي في أوروبا وأمريكا الشمالية، حيث تم اعتماد 65 مليون هكتار في الفترة 2010–2022. ومع ذلك، تشير أحدث البيانات إلى أن مساحة الغابات المعتمدة انخفضت بمقدار 19 مليون هكتار (4 في المائة) بين عامي 2021 و2022.</p>
<p>زادت نسبة مساحة الغابات داخل المناطق المحمية على مستوى العالم من 17 في المائة إلى 18 في المائة من عام 2010 إلى عام 2020. كانت المنطقة دون الإقليمية التي تحتوي على أعلى نسبة من الغابات في المناطق المحمية في عام 2020 هي آسيا الوسطى (59 في المائة). وسجلت المنطقة نفسها أعلى زيادة نسبية من عام 2010 إلى عام 2020 (12 في المائة). تظهر أوروبا وأمريكا الشمالية أدنى نسبة مع 6 في المائة فقط من غاباتهما داخل المناطق المحمية.</p>
<p>زادت مساحة الغابات الخاضعة لخطة الإدارة من عام 2010 إلى عام 2020. تخضع معظم الغابات في أوروبا وآسيا لخطة إدارة، مع تسجيل زيادات عالية على وجه الخصوص منذ عام 2010 في آسيا الوسطى وشرق آسيا. ولا تزال نسبة الغابات الخاضعة لخطط الإدارة أقل من الثلث، وإن كانت تتزايد ببطء، في أمريكا اللاتينية ومنطقة البحر الكاريبي وأوقيانوسيا وأفريقيا جنوب الصحراء الكبرى.</p>
<p>زادت كمية الكتلة الحيوية فوق سطح الأرض في الغابات زيادة طفيفة بسبب ارتفاعها الملحوظ في شرق آسيا وأوروبا وغرب آسيا.</p>
<p>لا يزال المعدل السنوي لتغير الغابات مستقرًا نسبيًا على المستوى العالمي (حوالي -0.1 في المائة)، مما يشير إلى أنه في حين يستمر فقدان الغابات، فإنه يفعل ذلك بمعدل أبطأ قليلاً. ولوحظ توسع الغابات في آسيا وأوروبا وأمريكا الشمالية في الفترة 2010–2020، في حين سجلت خسائر كبيرة في الغابات في أفريقيا وجنوب شرق آسيا، وكذلك في أمريكا اللاتينية ومنطقة البحر الكاريبي. وتعزى هذه الخسائر بشكل رئيسي إلى التوسع في الزراعة. لا تزال إزالة الغابات وتدهورها من التحديات الرئيسية، لا سيما في المناطق المدارية وأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية، مما يشير إلى الحاجة إلى مزيد من الإجراءات للحد من إزالة الغابات وتنفيذ ممارسات الإدارة المستدامة للغابات والأراضي.</p>
<p>على الرغم من أنه لا يزال من الصعب قياس الآثار القصيرة والطويلة الأجل لوباء COVID -19 على الغابات، فمن المحتمل أن يكون الوباء قد أثر على الغابات والحراجة بسبب التغيرات في تدفق السكان من المناطق الحضرية والريفية والطلب الإضافي على بعض منتجات الغابات.</p>
<p>الغابات هي أكبر خزانات الكربون والتنوع البيولوجي على وجه الأرض. وهي مصدر أساسي للأغذية والسلع والخدمات وهي حيوية لسبل عيش أفقر السكان والمجتمعات الريفية. ينبغي مواصلة الجهود العالمية والإقليمية للحفاظ على النظم الإيكولوجية للغابات وكذلك وظائفها الاجتماعية والاقتصادية والبيئية، مع التركيز بشكل خاص على المناطق المدارية والبلدان النامية.</p>
 </Container>
<div className="chart-container">
<div className="chart-title"><h2>الشكل 69. ألف - التقدم المحرز صوب تحقيق الإدارة المستدامة للغابات</h2></div>
<table className="table desktop-table">
<thead className="subcategory_thead enter" >
<tr>
<th className="border-0"> </th>
<th className="pb-0 w-custom">
<div style={{minWidth: '115px'}}><span><small>التقدم بين العقود 2000–2010 و2010–2020</small></span></div></th>
<th className="" colSpan="3">
<div><span><small>التقدم بين عامي 2010 و2020</small></span></div></th>
<th className="">
<div><span><small>التقدم بين عامي 2010 و2022</small></span></div></th>
<th className="">
<div><span><small>التقدم بين عامي 2015 و2022</small></span></div></th>
<th className="">
<div><span><small>التقدم بين عامي 2021 و2022</small></span></div></th>
</tr>
</thead>
<thead className="subcategory_thead table-prevalence-title enter">
<tr>
<th>منطقة أهداف التنم<br/>ية المستدامة</th>
<th className="rotate">
<div><span>المعدل السنوي <br/>لتغير مساحة الغابات*</span></div></th>
<th className="rotate pb-0">
<div><span>مخزون الكتلة الحيو<br/>ية فوق سطح الأرض في <br/>الغابات (طن/هكتار)</span></div></th>
<th className="rotate pb-0">
<div><span>نسبة مساحة الغابات داخل<br/> المناطق المحمية<br/> المنشأة قانونيًا</span></div></th>
<th className="rotate pb-0">
<div><span>نسبة مساحة الغابات<br/> في إطار خطة طويلة <br/>الأجل لإدارة الغابات</span></div></th>
<th className="rotate pb-0">
<div><span>منطقة حرجية م<br/>عتمدة (2010–2022)</span></div></th>
<th className="rotate pb-0">
<div><span>منطقة حرجية <br/>معتمدة (2015–2022)</span></div></th>
<th className="rotate">
<div><span>منطقة حرجية م<br/>عتمدة (2021–2022)</span></div></th>
</tr>
</thead>
<thead className="othcategory_thead enter">			
<tr>
<th scope="row" className="teal">العالم</th>
    <td>
        <span className="circle-y"></span>
    </td>
    <td>
        <span className="circle-g"></span>

    </td>
    <td>
        <span className="circle-r"></span>

    </td>
    <td>
        <span className="circle-g"></span>

    </td>
    <td>
        <span className="circle-g"></span>

    </td>
    <td>
        <span className="circle-g"></span>

    </td>
    <td>
        <span className="circle-r"></span>

    </td>
</tr>
</thead>
<tbody className="enter">
<tr>
<th scope="row" className="font-weight-normal grey">آسيا الوسطى وجنوب آسيا</th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">آسيا الوسطى</li></ul></th>
    <td ><span className="circle-g"></span></td>
    <td ><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td> </td>
    <td> </td>
    <td> </td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">جنوب آسيا</li></ul></th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal grey">شرق آسيا وجنوب شرق آسيا</th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">شرق آسيا</li></ul></th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">جنوب شرق آسيا</li></ul></th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal grey">غربي آسيا وشمال أفريقيا</th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">شمال أفريقيا</li></ul></th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td scope="row" className="grey"> </td>
    <td scope="row" className="grey"> </td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">غرب آسيا</li></ul></th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td scope="row" className="grey"> </td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal grey">أفريقيا جنوب الصحراء</th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal grey">أمريكا الشمالية وأوروبا الغربية</th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">أوروبا</li></ul></th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">أمريكا الشمالية</li></ul></th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal grey">أمريكا اللاتينية ومنطقة البحر الكاريبي</th>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="font-weight-normal grey">أوقيانوسيا</th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th><ul className="mb-0"><li className="list-unstyled font-weight-normal">أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)</li></ul></th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
</tr>
<tr>
<th><ul className="mb-0"><li className="list-unstyled font-weight-normal">أستراليا ونيوزيلندا</li></ul></th>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="teal">البلدان النامية غير الساحلية (LLDCs)</th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="teal">أقل البلدان نموًا (LDCs)</th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
</tr>
<tr>
<th scope="row" className="teal">الدول الجزرية الصغيرة النامية (SIDS)</th>
    <td><span className="circle-r"></span></td>
    <td><span className="circle-y"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-g"></span></td>
    <td><span className="circle-r"></span></td>
</tr>
</tbody>
</table>
<table className="table mobile-table">
<tbody>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">العالم</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">آسيا الوسطى وجنوب آسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">آسيا الوسطى</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">جنوب آسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">شرق آسيا وجنوب شرق آسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">شرق آسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">جنوب شرق آسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">غربي آسيا وشمال أفريقيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">شمال أفريقيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">غرب آسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أفريقيا جنوب الصحراء</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أمريكا الشمالية وأوروبا الغربية</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أوروبا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أمريكا الشمالية</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أمريكا اللاتينية ومنطقة البحر الكاريبي</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أوقيانوسيا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أستراليا ونيوزيلندا</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">البلدان النامية غير الساحلية (LLDCs)</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">أقل البلدان نموًا (LDCs)</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td colSpan="2" className="country text-center font-weight-bold">الدول الجزرية الصغيرة النامية (SIDS)</td>
</tr>
<tr>
<td className="data border-left-yellow">المعدل السنوي لتغير مساحة الغابات*</td>
<td className="data red"></td>
</tr>
<tr>
<td className="data border-left-green">مخزون الكتلة الحيوية فوق سطح الأرض في الغابات (طن/هكتار)</td>
<td className="data yellow"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات داخل المناطق المحمية المنشأة قانونيًا</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">نسبة مساحة الغابات في إطار خطة طويلة الأجل لإدارة الغابات</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2010–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2015–2022)</td>
<td className="data green"></td>
</tr>
<tr>
<td className="data border-left-green">منطقة حرجية معتمدة (2021–2022)</td>
<td className="data red"></td>
</tr>
</tbody>
</table>
<ul className="list-unstyled list-inline text-center legend legend-table mt-4 half-width-entries">
                    <li className="list-inline-item"><span className="point position-static"></span>تغيير إيجابي</li>
                    <li className="list-inline-item"><span className="point position-static"></span>لا/تغيير بسيط</li>
                    <li className="list-inline-item"><span className="point position-static"></span>التغيير السلبي</li>
                    <li className="list-inline-item"><span className="point position-static"></span>لا توجد منطقة معتمدة</li>
                </ul>
<p className="note text-center">ملاحظة: * يتم احتساب معدل التغير السنوي في مساحة الغابات باستخدام صيغة الفائدة المركبة.<br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></p>
</div>
<ContainerChart
                title="الشكل70. مساحة الغابات المعتمدة (1000 هكتار) "
                legend={[
                    {title: '2010', color: '#e2f0d9'},
                    {title: '2015', color: '#a9d18e'},
                    {title: '2022', color: '#70ad47'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig70" download>https://doi.org/10.4060/CC7088EN-fig70</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure70}
                />
</ContainerChart>
<Container>
		                <div id="section15.3.1">
                    <HeaderSdg 
                        title="المؤشر 15.3.1"
                        subtitle={["نسبة الأراضي المتدهورة على إجمالي مساحة الأراضي", <sup>8</sup>]}
                        badges={[
                            {color: '#ffff05', text: 'تقييم الحالة العالمية: مسافة معتدلة إلى الهدف'},
                            { color: '#ff6261', text: 'العالمي: التدهور'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'الهدف 15.3',
                            text: '15-3 مكافحة التصحر، وترميم الأراضي والتربة المتدهورة، بما في ذلك الأراضي المتضررة من التصحر والجفاف والفيضانات، والسعي إلى تحقيق عالمٍ خالٍ من ظاهرة تدهور الأراضي، بحلول عام 2020'
                        }}
                    />
                </div>
<p><i>يستمر الاتجاه السلبي في تدهور الأراضي، مما يؤثر على حياة 1.3 مليار شخص</i></p>
<p>علاوة على ذلك، بين عامي 2015 و2019، كان العالم يفقد ما لا يقل عن 100 مليون هكتار من الأراضي الصحية والمنتجة كل عام. وهذا يعادل ضعف مساحة جرينلاند المفقودة على مدى 4 سنوات. وتؤثر هذه الاتجاهات المتدهورة على حياة 1.3 مليار شخص، يقدر أنهم معرضون بشكل مباشر لتدهور الأراضي. من عام 2000 إلى عام 2019، في شرق آسيا وأمريكا اللاتينية ومنطقة البحر الكاريبي وآسيا الوسطى، تدهور ما لا يقل عن 20 في المائة من إجمالي مساحة الأراضي، في حين كانت معظم المناطق الأخرى أكثر من 10 في المائة. تظهر الاتجاهات منذ عام 2015 أن الأراضي في أفريقيا جنوب الصحراء الكبرى وغرب آسيا وأمريكا اللاتينية ومنطقة البحر الكاريبي وجنوب آسيا تتدهور بشكل أسرع بكثير من المتوسط العالمي، مع زيادات تتراوح بين 6 و8 في المائة. هذه تقديرات متحفظة تستند إلى ثلاثة مؤشرات فرعية فقط: التغيرات في الغطاء الأرضي وإنتاجية الأراضي والكربون العضوي في التربة.</p>
<p>وحددت البلدان الأنشطة البشرية، مثل التوسع الحضري وإزالة الغابات وتحويل الأراضي العشبية، التي تكثفت بسبب تغير المناخ، باعتبارها الدوافع المباشرة لتدهور الأراضي. تكبدت الأراضي العشبية بعضًا من أكبر الخسائر في إنتاجية الأراضي، تليها الأراضي الزراعية والمناطق المغطاة بالأشجار. وأشارت البلدان المبلغة إلى ضرورة معالجة الدوافع غير المباشرة، مثل الاتجاهات الديموغرافية والاقتصادية، والتحديات المؤسسية والإدارية، والفجوات في الاستثمار والوصول إلى التكنولوجيا، لتمكين الاستجابة الفعالة لتدهور الأراضي.</p>
<p>في منتصف تنفيذ أهداف التنمية المستدامة، إذا استمرت هذه الاتجاهات المقلقة في تدهور الأراضي، فسيكون من الضروري استعادة 1.5 مليار هكتار بحلول عام 2030 لضمان عالم خالٍ من تدهور الأراضي. ومع ذلك، إذا تم تجنب تدهور جديد للأراضي وتسريع تنفيذ الالتزامات الحالية لاستعادة مليار هكتار، فلن يتحقق هدف الحياد فحسب ؛ بل سيتم تجاوزه بحلول عام 2030. وسيتطلب ذلك استثمارات أكبر في حفظ الأراضي وإدارتها المستدامة واستعادتها، من خلال التخطيط المتكامل لاستخدام الأراضي والضمانات البيئية والاجتماعية القوية.</p>
<p>تشمل استعادة الأراضي مجموعة واسعة من ممارسات الإدارة المستدامة للأراضي والمياه التي يمكن تطبيقها على: (1) الحفاظ على المناطق الطبيعية أو «إعادة تأهيلها «؛ (2) الإنتاج الغذائي الإيجابي للطبيعة» الراقي «في المناظر الطبيعية الريفية ؛ و(3) المناطق الحضرية» الخضراء «والبنية التحتية وسلاسل التوريد. تعزز أجندة استعادة الأراضي استراتيجية متعددة المنافع تعمل على عكس تدهور الأراضي وفقدان التنوع البيولوجي في الماضي، مع زيادة الأمن الغذائي والمائي، وتحسين سبل العيش والتخفيف من آثار تغير المناخ والتكيف معه.</p>
<p>استعادة الأراضي هي مسؤولية مشتركة – لكل شخص دور يلعبه لأن لكل شخص مصلحة في صحة الأرض، الآن وفي المستقبل. يمكن للحكومات والشركات والمجتمعات استعادة الأراضي معًا من خلال السعي إلى التقارب والتكامل. يمكن إدارة الأولويات البيئية والإنمائية بمسؤولية لإنشاء فسيفساء أكثر صحة لاستخدامات الأراضي دون المساس باحتياجات وتطلعات الأجيال الحالية والمستقبلية.</p>
</Container>
<ContainerChart
                title="الشكل 71. نسبة الأراضي المتدهورة، النسبة المئوية (2015 و2019)"
                legend={[
                    {title: '2015', color: '#a9d18e'},
                    {title: '2019', color: '#e2f0d9'},
                ]}
                note={<span>ملاحظة: (1) باستثناء جزر المالديف ؛ (2) باستثناء الولايات المتحدة الأمريكية ؛ (3) باستثناء الاتحاد الروسي وبيلاروس والدانمرك وسويسرا ولكسمبرغ ومالطة وموناكو والنرويج ؛ (4) باستثناء أنغولا وجزر القمر ؛ (5) باستثناء بروني دار السلام وسنغافورة ؛ (6) باستثناء بربادوس وغرينادا ؛ (7) باستثناء اليابان وجمهورية كوريا.<br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig71" download>https://doi.org/10.4060/CC7088EN-fig71</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure71}
                />
</ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 72. الوضع الحالي لمساحة الأراضي المتدهورة (2019)"
                legend={[
                     {title: 'تم تحقيق الهدف بالفعل', color: '#00a700'},
                    {title: 'قريب من الهدف', color: '#2acb2a'},
		    {title: 'مسافة متوسطة لتحقيق الهدف', color: '#ffff05'},
		    {title: 'بعيد عن الهدف', color: '#ffa500'},
		    {title: 'بعيد للغاية عن الهدف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map72' src="fig72.html" width='100%'  height='500px'/>

            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 73. الاتجاه في تدهور الأراضي العالمي (2015–2019)"
                legend={[
                    {title: 'تم تحقيق الهدف بالفعل', color: '#00a700'},
                    {title: 'على المسار الصحيح', color: '#2acb2a'},
		    {title: 'على الطريق ولكن ببطء شديد', color: '#ffff05'},
		    {title: 'لا يوجد تحسن', color: '#ffa500'},
		    {title: 'تلف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span><br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 12 <a href="http://www.fao.org/sustainable-development-goals/indicators/en">يوليو</a>2023. <a href="http://www.fao.org/sustainable-development-goals-data-portal/data/ar">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (تم تعديله ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. والحدود النهائية بين السودان وجنوب السودان لم تُحدد بعد.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map73' src="fig73.html" width='100%'  height='500px'/>

            </ContainerChart>
<Container>
<div id="section15.4.2">
                    <HeaderSdg 
                        title="مؤشر أهداف التنمية المستدامة 15.4.2"
                        subtitle="(أ) مؤشر الغطاء الأخضر الجبلي و(ب) نسبة الأراضي الجبلية المتدهورة"
                        badges={[
                            {color: '#FFC000', text: 'تقييم الحالة العالمية: في متوسط القيم القطرية تقييم الاتجاه'},
                            { color: '#92D050', text: 'العالمي: التحسن'},
		       {color: '#92D050', text: 'تقييم الحالة العالمية: قريب من الهدفتقييم التقدم'},
                            { color: '#ff6261', text: 'العالمي: لا يوجد تحسن'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'الهدف 15.4',
                            text: 'ضمان الحفاظ على النظم الإيكولوجية الجبلية، بما في ذلك تنوعها البيولوجي، من أجل تعزيز قدرتها على توفير الفوائد الضرورية للتنمية المستدامة، بحلول عام 2030.'
                        }}
                    />
                </div>

<p><i>تبلغ نسبة الأراضي الجبلية المتدهورة 1.6 في المائة من المساحة الجبلية في العالم</i></p>
<p>ظل الغطاء الأخضر الجبلي مستقرًا تقريبًا، عند حوالي 78 في المائة خلال الفترة 2000–2018، مع انخفاض غير ملحوظ (0.05 في المائة) منذ عام 2015. يوفر تصنيف المناطق الجبلية حسب الغطاء الأرضي والمنطقة الجغرافية رؤى إضافية، مما يسمح بتصور كيفية تشكيل الخصائص الفيزيائية الحيوية واستخدامات الأراضي التاريخية والحديثة لمناظرها الطبيعية(Figure 74).</p>
</Container>
<ContainerChart
                title="الشكل 74. مؤشر الغطاء الأخضر الجبلي حسب نوع الغطاء الأرضي (2018)"
                legend={[
                    {title: 'الأسطح الاصطناعية', color: '#c00000', customCSSClass: 'half-width'},
                    {title: 'الأراضي الزراعية', color: '#fed966', customCSSClass: 'half-width'},
                    {title: 'مروج طبيعية', color: '#c4dda0', customCSSClass: 'half-width'},
                    {title: 'المناطق المغطاة بالأشجار', color: '#548135', customCSSClass: 'half-width'},
                    {title: 'المناطق المغطاة بالشجيرات', color: '#82b99c', customCSSClass: 'half-width'},
                    {title: 'الأراضي الرطبة', color: '#65b3d6', customCSSClass: 'half-width'},
                    {title: 'مناطق ذات نباتات قليلة', color: '#dcca8f', customCSSClass: 'half-width'},
                    {title: 'أرض قاحلة أرضية', color: '#9a8f72', customCSSClass: 'half-width'},
                    {title: 'الثلوج والأنهار الجليدية الدائمة', color: '#d6dce5', customCSSClass: 'half-width'},
                    {title: 'المسطحات المائية الداخلية', color: '#5475a8', customCSSClass: 'half-width'},		
                ]}
                note={<span>ملاحظة: المحور الأيمن – توزيع أنواع الغطاء الأرضي في مختلف مناطق أهداف التنمية المستدامة في عام 2018. يشير ارتفاع كل شريط إلى إجمالي المساحة الجبلية لكل منطقة من مناطق أهداف التنمية المستدامة. المحور الأيسر – قيم مؤشر الغطاء الأخضر الجبلي في عام 2018، ممثلة كنقاط سوداء.<br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure74}
                />
</ContainerChart>
<Container>
<p>المناطق المغطاة بالأشجار هي النوع السائد من الغطاء الأرضي الجبلي على مستوى العالم، لا سيما في أوقيانوسيا (90 في المائة من إجمالي المساحة الجبلية) وأوروبا وأمريكا الشمالية (52 في المائة) وأمريكا اللاتينية ومنطقة البحر الكاريبي (42 في المائة) وشرق وجنوب آسيا (38 في المائة) وأفريقيا جنوب الصحراء الكبرى (35 في المائة). هناك استثناءان فقط: شمال أفريقيا وغرب آسيا، حيث تهيمن الأراضي القاحلة (40 في المائة) والأراضي الزراعية (25 في المائة)، ووسط وجنوب آسيا، حيث الأراضي القاحلة (26 في المائة)، والأراضي العشبية (24 في المائة) والأراضي الزراعية (20 في المائة) هي أكثر أنواع الغطاء الأرضي انتشارًا.</p>
<p>تميل المناطق الحبلية وشبه الاستوائية التي تتميز بسلاسل جبلية منخفضة أو متوسطة الارتفاع، مثل أوقيانوسيا، إلى إظهار أعلى قيم الغطاء الأخضر (99 بالمائة). وعلى العكس من ذلك، تميل المناطق التي تتميز بسلاسل جبال عالية الارتفاع تقع في المناطق المعتدلة والشمالية، حيث تكون الظروف البيئية أقل ملاءمة لنمو الغطاء النباتي، مثل آسيا الوسطى وأمريكا الشمالية وأوروبا، إلى إظهار قيم أقل للغطاء الأخضر (64 في المائة و76 في المائة على التوالي). تميل المناطق القاحلة مثل شمال إفريقيا وغرب آسيا أيضًا إلى إظهار قيم منخفضة لمساحة الغطاء الأخضر (46 في المائة).</p>
<p>تعد التغيرات الضارة في الغطاء الأرضي واستخدام الأراضي من العوامل المهمة المساهمة في فقدان التنوع البيولوجي الأرضي، بما في ذلك النظم الإيكولوجية الجبلية. وتقيس نسبة الأراضي الجبلية المتدهورة ذلك من خلال حساب مساحة المنطقة الجبلية حيث قد تشير التغيرات في الغطاء الأرضي إلى انخفاض أو فقدان التنوع البيولوجي أو وظائف النظم الإيكولوجية الجبلية أو الخدمات التي تعتبر مرغوبة في سياق محلي أو وطني. ولهذا الغرض، فإن تحولات الغطاء الأرضي التي تشير إلى انخفاض أو فقدان التنوع البيولوجي وخدمات النظم الإيكولوجية الجبلية تعتبر تدهورًا للأراضي الجبلية.</p>
<p className="text-center mb-0"><span><i>الجدول 4. الأحزمة المناخية الحيوية الجبلية وإعادة تصنيفها لتصنيف بيانات مؤشر أهداف التنمية المستدامة 15.4.2</i></span></p>
                    <table className="annex-table text-center">
                        <thead>
<tr className="text-left">
<th className="text-right">أحزمة المناخ الحيوي</th>
<th className="text-right">متوسط درجة الحرارة لموسم النمو</th>
<th className="text-right">طول موسم النمو</th>
<th className="text-right">لأحزمة المناخية الحيوية المعتمدة لمؤشر أهداف التنمية المستدامة 15.4.2</th>
</tr>
</thead>
<tbody>
<tr className="text-left">
<td className="text-right"><b>مناطق الثلج الدائم</b></td>
<td className="text-right">&lt; 3.5 درجة مئوية</td>
<td className="text-right">&lt; 10 أيام</td>
<td className="text-right">مناطق الثلج الدائم</td>
</tr>
<tr className="text-left">
<td className="text-right"><b>جبال الألب العليا</b></td>
<td className="text-right">&lt; 3.5 درجة مئوية</td>
<td className="text-right">&gt; 10 أيام و&lt; 54 يومًا</td>
<td rowspan="2" className="text-right">جبال الألب</td>
</tr>
<tr className="text-left">
<td className="text-right"><b>جبال الألب السفلى</b></td>
<td className="text-right">&lt; 6.4 درجة مئوية</td>
<td className="text-right">&lt; 54 يومًا</td>
</tr>
<tr>
<td colspan="4" className="text-center"><b>خط الأشجار</b></td>
</tr>
<tr className="text-left">
<td className="text-right"><b>المناطق الجبلية المرتفعة</b></td>
<td className="text-right">&gt; 6.4 درجة مئوية و&#x2265; 10 درجات مئوية</td>
<td className="text-right">---</td>
<td rowspan="2" className="text-right">جبلي</td>
</tr>
<tr className="text-left">
<td className="text-right"><b>المناطق الجبلية المنخفضة</b></td>
<td className="text-right">&gt; 10 درجة مئوية و&#x2265; 15 درجة مئوية</td>
<td className="text-right">---</td>
</tr>
<tr className="text-left">
<td className="text-right"><b>المنطقة الجبلية المتبقية مع الصقيع</b></td>
<td className="text-right">&gt; 15 درجة مئوية</td>
<td className="text-right" rowspan="2">---</td>
<td className="text-right" rowspan="2">المناطق الجبلية المتبقية</td>
</tr>
<tr className="text-left">
<td className="text-right"><b>المنطقة الجبلية المتبقية بدون صقيع</b></td>
<td className="text-right">&gt; 15 درجة مئوية</td>
</tr>
</tbody>
</table>
<p className="note text-center">ملاحظة: يمكن تقسيم الجبال رأسيًا إلى سبعة أحزمة مناخية حيوية بناءً على متوسط درجات الحرارة، مما يساعد على حساب التغير العرضي في ارتفاع المناطق المتشابهة حراريًا في جبال العالم. لأغراض المؤشر 15.4.2، يتم تجميع هذه الأحزمة المناخية الحيوية السبعة في أربعة (نيفال، جبال الألب، مونتين والمناطق الجبلية المتبقية)<br/>المصدر: Körner، C.، Paulsen، J. &amp; Spehn، E. 2011. <i>تعريف للجبال وأحزمتها المناخية الحيوية للمقارنات العالمية لبيانات التنوع البيولوجي</i>. علم نبات جبال الألب، 121: 73–78.</p>
<p>تشير البيانات العالمية المتاحة إلى أن المنطقة التي حدثت فيها تغيرات ضارة في الغطاء الأرضي خلال الفترة 2000–2018 تمثل حوالي 1.6 في المائة من إجمالي المساحة الجبلية في العالم. تُظهر البيانات المصنفة أن الأحزمة الجبلية الأكثر تضررًا من التغيرات الضارة في الغطاء الأرضي كانت أحزمة جبال الألب (1.8 في المائة) والجبل (1.7 في المائة)، في حين كانت مناطق نيال هي الأقل تضررًا (0.08 في المائة(Figure 75).<sup onClick={() => handleClickOpen('يجب تفسير هذه القيم بحذر، نظرًا لأن التغييرات في منطقة الثلج والجليد الدائمين لم يتم التقاطها بعد من قبل مجموعة بيانات الغطاء الأرضي العالمية المستخدمة للتحليل (الوكالة الفضائية الأوروبية، 2017).')}>9</sup> يُظهر التصنيف حسب مناطق أهداف التنمية المستدامة والأحزمة المناخية الحيوية أن المناطق التي تحتوي على أعلى نسبة من الأراضي الجبلية المتدهورة هي مناطق جبال الألب في أوروبا وأمريكا الشمالية (2.3 في المائة)، تليها المناطق الجبلية في وسط وجنوب آسيا (2.2 في المائة) والأحزمة الجبلية السفلية في شرق وجنوب آسيا (2.1 في المائة).</p>
</Container>
<ContainerChart
                title="الشكل75. نسبة الأراضي الجبلية المتدهورة في مختلف مناطق أهداف التنمية المستدامة، مصنفة حسب الحزام المناخي الحيوي، 2000–2018"
                legend={[
                    {title: 'نيفال', color: '#a5a5a5', customCSSClass: 'half-width'},
                    {title: 'جبال الألب', color: '#e6ddcc', customCSSClass: 'half-width'},
                    {title: 'مونتان', color: '#a9b6a2', customCSSClass: 'half-width'},
                    {title: 'المنطقة الجبلية المتبقية', color: '#6c8b8d', customCSSClass: 'half-width'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure75}
                />
</ContainerChart>
<Container>
<p>أخيرًا، يُظهر تحليل للتغيرات في أنواع الغطاء الأرضي في المناطق الجبلية في العالم أن مساحة الأسطح الاصطناعية زادت بأكثر من الضعف (زيادة 106 في المائة) خلال الفترة 2000–2018، لا سيما تحت خط الأشجار (المناطق الجبلية والمناطق الجبلية المتبقية). كما شهدت مناطق الأراضي الرطبة تحت خط الأشجار انخفاضًا كبيرًا خلال نفس الفترة (الشكل 76).</p>
</Container>
<ContainerChart
                title="الشكل 76. التغيرات في مساحة أنواع الغطاء الأرضي المختلفة في المنطقة الجبلية في العالم خلال الفترة 2000–2018"
                legend={[
                    {title: 'نيفال', color: '#a5a5a5', customCSSClass: 'half-width'},
                    {title: 'جبال الألب', color: '#e6ddcc', customCSSClass: 'half-width'},
                    {title: 'مونتان', color: '#a9b6a2', customCSSClass: 'half-width'},
                    {title: 'المنطقة الجبلية المتبقية', color: '#6c8b8d', customCSSClass: 'half-width'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure76}
                />
</ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 77. الوضع الحالي لمؤشر الغطاء الأخضر الجبلي، حسب الخُمس (2018)"
                legend={[
                    {title: 'الخُمس الخامس', color: '#00a700'},
                    {title: 'الخُمس الرابع', color: '#2acb2a'},
		    {title: 'الخُمس الثالث', color: '#ffff05'},
		    {title: 'الخُمس الثاني', color: '#ffa500'},
		    {title: 'الخُمس الأول', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span><br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 12 <a href="http://www.fao.org/sustainable-development-goals/indicators/en">يوليو</a>2023. <a href="http://www.fao.org/sustainable-development-goals-data-portal/data/ar">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (تم تعديله ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. والحدود النهائية بين السودان وجنوب السودان لم تُحدد بعد.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map77' src="fig77.html" width='100%'  height='500px'/>

            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 78. الاتجاه في تحسين مؤشر الغطاء الأخضر الجبلي حسب المنطقة (2015–2018)"
                legend={[
                    {title: 'التحسين', color: '#00a700'},
                    {title: 'تحسن طفيف أو معدوم', color: '#2acb2a'},
		    {title: 'تدهور طفيف', color: '#ffa500'},
		    {title: 'تلف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},		   
                ]}
                source={<span><br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 12 <a href="http://www.fao.org/sustainable-development-goals/indicators/en">يوليو</a>2023. <a href="http://www.fao.org/sustainable-development-goals-data-portal/data/ar">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (تم تعديله ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. والحدود النهائية بين السودان وجنوب السودان لم تُحدد بعد.</span>}>                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map78' src="fig78.html" width='100%'  height='500px'/>

            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 79. الوضع الحالي لتدهور الأراضي الجبلية (2018)"
                legend={[
                    {title: 'تم تحقيق الهدف بالفعل', color: '#00a700'},
                    {title: 'قريب من الهدف', color: '#2acb2a'},
		    {title: 'مسافة متوسطة إلى الهدف', color: '#ffff05'},
		    {title: 'بعيد عن الهدف', color: '#ffa500'},
		    {title: 'بعيد للغاية عن الهدف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},			   
                ]}
                source={<span><br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 12 <a href="http://www.fao.org/sustainable-development-goals/indicators/en">يوليو</a>2023. <a href="http://www.fao.org/sustainable-development-goals-data-portal/data/ar">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (تم تعديله ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. والحدود النهائية بين السودان وجنوب السودان لم تُحدد بعد.</span>}>                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map79' src="fig79.html" width='100%'  height='500px'/>
            </ContainerChart>
		{/* Interactive Map  */}
            <ContainerChart
                title="الشكل 80. الاتجاه في تدهور الأراضي الجبلية (2015–2018)"
                legend={[
                    {title: 'تم تحقيق الهدف بالفعل', color: '#00a700'},
                    {title: 'على المسار الصحيح لتحقيق الهدف', color: '#2acb2a'},
		    {title: 'على الطريق ولكن ببطء شديد لتحقيق الهدف', color: '#ffff05'},
		    {title: 'على الطريق ولكن ببطء شديد لتحقيق الهدف', color: '#ffa500'},
		    {title: 'تلف', color: '#ff0000'},
		    {title: 'بيانات غير كافية', color: '#808080'},			   
                ]}
                source={<span><br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. اقتُبس في 12 <a href="http://www.fao.org/sustainable-development-goals/indicators/en">يوليو</a>2023. <a href="http://www.fao.org/sustainable-development-goals-data-portal/data/ar">www.fao.org/sustainable-development-goals-data-portal/data/ar</a> (تم تعديله ليتوافق مع قسم المعلومات الجغرافية المكانية للأمم المتحدة، 2023).</span>}

                note={<span>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. ولم تُحدد الحدود النهائية بين السودان وجنوب السودان بعد. ومل تقرر بعد الحدود النهائية بني جمهورية السودان وجمهورية جنوب السودان. مل يتم تحديد الوضع النهايئ ملنطقة أبيي بعد. .ثمة نزاع قائم بين حكومتي الأرجنتين والمملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية بشأن السيادة على جزر فوكلاند (مالفيناس<br/>يمثِّل الخط المنقَّط تقريبيّاً خطَّ المراقبة في جامو وكشمير الذي اتفقت عليه باكستان والهند. لم يتَّفق الطرفان حتى الآن على الوضع النهائي لجامو وكشمير. والحدود النهائية بين السودان وجنوب السودان لم تُحدد بعد.</span>}>                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map80' src="fig80.html" width='100%'  height='500px'/>

            </ContainerChart>
 <Container>
                <div id="section15.6.1">
                    <HeaderSdg
                        title="مؤشر أهداف التنمية المستدامة 15.6.1"
                        subtitle={["عدد البلدان التي اعتمدت أطرًا تشريعية وإدارية وسياساتية لضمان التقاسم العادل والمنصف للمنافع", <sup>10</sup>]}
                        // badges={[
                        //     {color: '#ffbf02', text: 'Global status assessment: Not possible due to absence of numerical yardstick in target.'},
                        //     {color: '#ff6261', text: 'Global trend assessment: Slight or no improvement.'},
                        // ]}
                        target={{
                            sdg: "15",
                            title: 'الهدف 15.6',
                            text: 'تعزيز التقاسم العادل والمنصف للمنافع الناشئة عن استخدام الموارد الجينية وتعزيز الوصول المناسب إلى هذه الموارد، على النحو المتفق عليه دوليًا.'
                        }}
                    />
                </div>
                <div className="text-in-box mt-5">
<HeaderSdg
                        title="مؤشر هدف التنمية المستدامة 15.6.1"
                        subtitle="البلدان التي هي أطراف متعاقدة في المعاهدة الدولية بشأن الموارد الوراثية النباتية للأغذية والزراعة "
                         badges={[
                             {color: '#cecece', text: 'الوضع الحالي: لا يمكن عدم وجود مقياس رقمي في الهدف'},
                             {color: '#00a700', text: 'الاتجاه: التحسين'},
                         ]}
                                            />
	  <Subtitle text="البلدان التي لديها أطر أو تدابير تشريعية وإدارية وسياساتية تم الإبلاغ عنها من خلال نظام الإبلاغ عبر الإنترنت بشأن الامتثال للمعاهدة الدولية بشأن الموارد الوراثية النباتية للأغذية والزراعة " />
		   
<div className="sdg-header" id="header2-1-2">
    <div className="text-center">
<div className="badge badge-pill" style={{background: '#cecece'}}>الوضع الحالي: غير ممكن بسبب عدم وجود مقياس رقمي في الهدف</div><br/>
<div className="badge badge-pill" style={{background: '#00a700'}}>الاتجاه: التحسين</div>
    </div>
</div>
                 
			     <Subtitle text="إجمالي عدد اتفاقيات نقل المواد القياسية التي تنقل الموارد الوراثية النباتية للأغذية والزراعة إلى البلاد" />
<div className="sdg-header" id="header2-1-2">
    <div className="text-center">
<div className="badge badge-pill" style={{background: '#cecece'}}>الوضع الحالي: غير ممكن بسبب عدم وجود مقياس رقمي في الهدف</div><br/>
<div className="badge badge-pill" style={{background: '#00a700'}}>الاتجاه: التحسين</div>
    </div>
</div>
                  </div>
<p className="mt-5"><i>تجدد صفقة التنوع البيولوجي الجديدة الانتباه إلى التقاسم العادل والمنصف للمنافع الناشئة عن استخدام الموارد الجينية</i></p>
<p>منذ دخول بروتوكول ناغويا بشأن الحصول على الموارد الجينية والتقاسم العادل والمنصف للمنافع الناشئة عن استخدامها الملحق باتفاقية التنوع البيولوجي حيز التنفيذ في عام 2014، ارتفع عدد الأطراف التي صدقت عليه إلى 138، بما في ذلك 137 دولة والاتحاد الأوروبي، وهو ما يمثل 70 في المائة من جميع الأطراف في اتفاقية التنوع البيولوجي.</p>
<p>ومع ذلك، مع اقتراب بروتوكول ناغويا من التصديق العالمي، لا يزال يتعين على العديد من البلدان وضع التدابير التشريعية أو الإدارية أو السياساتية اللازمة لضمان التقاسم العادل والمنصف للمنافع الناشئة عن استخدام الموارد الجينية والمعارف التقليدية المرتبطة بها. في عام 2022، لم تنشر أي دولة إضافية أي تدابير لغرفة تبادل المعلومات بشأن الحصول على الموارد وتقاسم المنافع، مما أبقى العدد عند 68 اعتبارًا من عام 2021. أصدرت خمسة وعشرون دولة 4440 شهادة امتثال معترف بها دوليًا (بزيادة قدرها 1000) كدليل على منح الموافقة المسبقة عن علم ووضع شروط متفق عليها بشكل متبادل للوصول في عام 2022.</p>
<p>بلغ عدد الأطراف المتعاقدة في المعاهدة الدولية بشأن الموارد الوراثية النباتية للأغذية والزراعة (المعاهدة الدولية للنباتات) 150 طرفًا، بما في ذلك الاتحاد الأوروبي، اعتبارًا من 1 يناير 2023، مع انضمام بلدين في عام 2022. بحلول نهاية عام 2022، قدمت 88 دولة تقريرها الوطني لتقديم معلومات حول تنفيذها لأحكام المعاهدة، بما في ذلك تدابير الحصول على الموارد وتقاسم المنافع ؛ وقدمت تسعة بلدان تقاريرها في عام 2022. كما ارتفع عدد اتفاقيات نقل المواد القياسية (SMTAs)، من 55566 في عام 2015 إلى 91352 في عام 2022، مما يشير إلى أن المزيد من المستخدمين يستفيدون من الوصول إلى الموارد الوراثية النباتية للبحث والتربية والتدريب.</p>
<p>من المحتمل أن تؤدي التأخيرات المبلغ عنها في العمليات التشريعية وفي تنفيذ أنشطة تنمية القدرات بسبب جائحة كوفيد-19 إلى تأخير التقدم نحو الهدف بالنسبة لبعض البلدان. من ناحية أخرى، كانت زيادة رقمنة تطوير القدرات والمواد التدريبية تطوراً إيجابياً في تسهيل تبادل المعرفة.</p>
<p>يدعم صندوق تقاسم المنافع، الذي أنشأه مجلس إدارة المعاهدة الدولية للنباتات، المشاريع التي تستفيد من الموارد الوراثية النباتية لإيجاد حلول للتحديات المعقدة المتعلقة بانعدام الأمن الغذائي والتغذوي وفقدان التنوع البيولوجي وتغير المناخ. انطلقت دورتها الخامسة في مايو 2022. صندوق تقاسم المنافع هو الآلية التشغيلية لتقاسم المنافع الناشئة عن النظام المتعدد الأطراف للمعاهدة الدولية للنباتات ويشمل تمويله الدخل القائم على المستخدم من النظام المتعدد الأطراف، بالإضافة إلى المساهمات الطوعية.</p>
<p>إن اعتماد إطار كونمينغ- مونتريال العالمي للتنوع البيولوجي في كانون الأول/ديسمبر 2022 في مونتريال، وكذلك قرار مؤتمر الأطراف في اتفاقية التنوع البيولوجي بتقاسم الفوائد الناشئة عن استخدام معلومات التسلسل الرقمي بشأن الموارد الجينية بشكل عادل ومنصف، يجدد الاهتمام بتنفيذ أطر الحصول على الموارد وتقاسم المنافع. في سياق هذا الإطار، سيتم وضع مؤشرات جديدة للوصول وتقاسم المنافع من قبل فريق خبراء تقني مخصص للهدف ج والغاية 13. ويتيح ذلك فرصة هامة لمواصلة تحسين جمع البيانات وتحليلها بشأن المنافع المتقاسمة من استخدام الموارد الجينية، وتسريع الجهود العالمية الرامية إلى حفظ الموارد الجينية واستخدامها على نحو مستدام، فضلا عن تعزيز التنفيذ المتعاضد لصكوك الحصول على الموارد وتقاسم المنافع.</p>
 </Container>
<ContainerChart
                title="الشكل 81. عدد اتفاقيات نقل المواد القياسية المتعلقة بالموارد الوراثية النباتية للأغذية والزراعة في العالم (2012–2022)"
                legend={[
                    {title: 'أستراليا ونيوزيلندا', color: '#5b9bd6', customCSSClass: 'half-width'},
                    {title: 'آسيا الوسطى وجنوب آسيا', color: '#ed7e31', customCSSClass: 'half-width'},
                    {title: 'شرق آسيا وجنوب شرق آسيا', color: '#a6a5a4', customCSSClass: 'half-width'},
                    {title: 'أمريكا اللاتينية ومنطقة البحر الكاريبي', color: '#ffbf00', customCSSClass: 'half-width'},
                    {title: 'شمال أفريقيا', color: '#4372c4', customCSSClass: 'half-width'},
                    {title: 'أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)', color: '#71ad49', customCSSClass: 'half-width'},
                    {title: 'أفريقيا جنوب الصحراء', color: '#265e91', customCSSClass: 'half-width'},
                    {title: 'غرب آسيا', color: '#9e480e', customCSSClass: 'half-width'},
                    {title: 'أوروبا وأمريكا الشمالية', color: '#636363', customCSSClass: 'half-width'},
                    {title: 'العالم', color: '#9b7200', customCSSClass: 'half-width'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure81}
                />
</ContainerChart>
<Container>
<p className="font-weight-bold" dir="auto">المراجع</p>
<p>وكالة الفضاء الأوروبية. 2017. <i>منتج الغطاء الأرضي CCI. دليل المستخدم الإصدار 2.0</i>. روما. مقتبس [8 يونيو 2023]. <a href="https://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf">https://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf</a></p>
<p>Körner، C.، Paulsen، J. &amp; Spehn، E. 2011. تعريف للجبال وأحزمتها المناخية الحيوية للمقارنات العالمية لبيانات التنوع البيولوجي. <i>علم نبات جبال الألب،</i> 121: 73–78.</p>
</Container>

            <Container>
                 <div className="footnotes">
            <p id="footnote8"><sup>8</sup> يخضع مؤشر أهداف التنمية المستدامة 15.3.1 لتوصيات اتفاقية الأمم المتحدة لمكافحة التصحر. منظمة الأغذية والزراعة هي وكالة مساهمة.</p>
	    <p id="footnote9"><sup>9</sup> يجب تفسير هذه القيم بحذر، نظرًا لأن التغييرات في منطقة الثلج والجليد الدائمين لم يتم التقاطها بعد من قبل مجموعة بيانات الغطاء الأرضي العالمية المستخدمة للتحليل (الوكالة الفضائية الأوروبية، 2017).</p>
	    <p id="footnote10"><sup>10</sup> يخضع مؤشر أهداف التنمية المستدامة 15.6.1 لتوصيات أمانة اتفاقية التنوع البيولوجي. منظمة الأغذية والزراعة هي وكالة مساهمة.</p>
	                     <br /><br /><br /><br />
		 </div>
            </Container>

        </React.Fragment>
    )
}


export default Sdg15;

